interface OppdagKpiRowProps {
  contactsToday: number;
  contactsWeek: number;
  meetingsWeek: number;
  followUpsLeft: number;
}

/** KPI-ene øverst i Oppdag (VIB-2986). Bare tall, ingen mål. */
export default function OppdagKpiRow({ contactsToday, contactsWeek, meetingsWeek, followUpsLeft }: OppdagKpiRowProps) {
  const tiles = [
    { label: "Kontakter i dag", value: contactsToday },
    { label: "Kontakter denne uken", value: contactsWeek },
    { label: "Møter booket denne uken", value: meetingsWeek },
    { label: "Oppfølginger igjen denne uken", value: followUpsLeft },
  ];
  return (
    <section aria-label="Dine tall" className="grid grid-cols-2 gap-px border-[1.5px] border-foreground bg-foreground lg:grid-cols-4">
      {tiles.map((t) => (
        <div key={t.label} className="bg-card p-4">
          <p className="text-xs text-muted-foreground">{t.label}</p>
          <p className="font-display text-3xl font-semibold tabular-nums">{t.value}</p>
        </div>
      ))}
    </section>
  );
}
